// product-form.js
class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.cartNotification = document.querySelector('cart-notification');

    if (this.form) {
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }
  }

  onSubmitHandler(event) {
    event.preventDefault();

    const submitButton = this.form.querySelector('[type="submit"]');
    submitButton.setAttribute('disabled', true);

    const formData = new FormData(this.form);
    formData.append(
      'sections',
      'cart-notification-product,cart-notification-button,cart-icon-bubble'
    );
    formData.append('sections_url', window.location.pathname);

    fetch(`${routes.cart_add_url}.js`, {
      method: 'POST',
      body: formData,
    })
      .then((response) => response.json())
      .then((parsedState) => {
        if (this.cartNotification) {
          this.cartNotification.renderContents(parsedState);
        }

        // ✅ Agregamos esta línea para forzar la actualización visual
        window.location.reload();
      })
      .catch((error) => {
        console.error('Error al agregar al carrito:', error);
      })
      .finally(() => {
        submitButton.removeAttribute('disabled');
      });
  }
}

customElements.define('product-form', ProductForm);

